import React, {useCallback, useEffect, useMemo, useState} from 'react';
import IEditorOptions from "../../models/IEditorOptions";
import {SelectBox} from "devextreme-react/select-box";
import ICustomSelectBoxData from "../../models/ICostumSelectBoxData";

function useTypesEquipements() {
    const typeEquipement: ICustomSelectBoxData[] = [{id: -1, description: "Indéterminé"}, {id: 260, description: "Autocaravane - Motorisé - Camping Car"}, {id: 240, description: "Caravane a sellette"}, {id: 250, description: "Caravane portée"}, {id: 280, description: "Location de chalet ou de roulotte"}, {id: 220, description: "Roulotte"}, {id: 230, description: "Roulotte hybride"}, {id: 200, description: "Tente"}, {id: 270, description: "Tente Prête-a-camper"}, {id: 210, description: "Tente-Roulotte"}];
    const [currentSelectedItem, setCurrentSelectedItem] = useState<ICustomSelectBoxData>();
    const editorOptions = useMemo((): IEditorOptions<ICustomSelectBoxData[]> => {
        return {
            searchEnabled: true,
            dataSource: typeEquipement,
            width: "max-content",
            displayExpr: "description",
            displayValue: "id",
            valueExpr: "id",
        }
    }, [])

    const TypesEquipementsSelectBox = useCallback((params: any) => {
        const {dataField, component, column, data} = params;
        const formOptions = component.option();
        const value = dataField ? formOptions.formData[dataField] : data[column.dataField];

        const onValueChanged = (args: any) => {
            component.updateData(dataField, args.value);
        }

        const onSelectionChanged = (e: any) => {
            setCurrentSelectedItem(e.selectedItem);
        }

        return (
            <SelectBox readOnly={formOptions.readOnly} onSelectionChanged={onSelectionChanged} dataSource={editorOptions.dataSource} displayExpr={editorOptions.displayExpr} displayValue={editorOptions.displayValue} valueExpr={editorOptions.valueExpr} value={value} onValueChanged={onValueChanged}/>
        )
    }, [editorOptions.dataSource, editorOptions.displayExpr, editorOptions.displayValue, editorOptions.valueExpr]);

    return {
        typeEquipementEditorOptions: editorOptions,
        typeEquipement: typeEquipement,
        currentTypeEquipement: currentSelectedItem,
        TypesEquipementsSelectBox
    }
}

export default useTypesEquipements;